window.Foxtheme = window.Foxtheme || {};

const PUB_SUB_EVENTS = {
  cartError: "cart-error",
  cartUpdate: "cart-update",
  cartClose:"cart-close",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  quantityUpdate: "quantity-update",
  quantityBoundries: "quantity-boundries",
  quantityRules: "quantity-rules",
};

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    // console.log('postProcessCallbacks',postProcessCallbacks)
    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    postProcessCallbacks?.forEach((callback) => {
      callback(newNode);     
    });
    
    const wrapper = document.getElementById('pify_size_chart_wrapper');
    if(document.body.classList.contains('template-product')){
      if (wrapper && wrapper.hasChildNodes()) {
        // console.log('Element has child nodes.');
      } else {
        // console.log('Element has no child nodes.');
        try {
          addFitSelector();
          addCustomButtons()
          
        } catch (error) {
            // console.log('error',error)
        }
      }
  }

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      setTimeout(()=>{
         yotpo.initWidgets(); /*ReInit Main review widget*/
        window.dispatchEvent(new Event('resize')); 
       })
    });

    setTimeout(()=>{
       if($(html).attr('id') == 'MainContent'){
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    })
  }
}

function generateDomFromString(value, tagName = "div") {
  const d = document.createElement(tagName);
  d.innerHTML = value;
  return d;
}

function getScrollbarWidth() {
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll";
  outer.style.msOverflowStyle = "scrollbar";
  document.body.appendChild(outer);
  const inner = document.createElement("div");
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}

function getSectionId(element) {
  if (element.hasAttribute("data-section-id"))
    return element.getAttribute("data-section-id");

  element = element.classList.contains("shopify-section")
    ? element
    : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;
  return new Promise((resolve, reject) => {
    const url = new URL(_url || window.location.href);
    url.searchParams.set("section_id", sectionId);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

    if (fromCache) {
      const cached = sectionCache.get(url);
      if (cached) return resolve(cached);
    }

    fetch(url, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) return res.text();
        reject(`Failed to load section: ${sectionId}`);
      })
      .then((html) => {
        const div = generateDomFromString(html);
        sectionCache.set(url, div);
        resolve(div);
      })
      .catch(reject);
  });
}

function loadAssets(files = [], id, callback = () => {}, options = {}) {
  const unique = id ? id : Math.random().toString(36).slice(2);
  if (!window.FoxTheme.loadjs.isDefined(id))
    window.FoxTheme.loadjs(files, unique);
  window.FoxTheme.loadjs.ready(unique, callback);
}

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    acc[name] = context && context[queryMethod](sl);
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

function addEventDelegate({
  context = document.documentElement,
  event = "click",
  selector,
  handler,
  capture = false,
}) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (
      let target = e.target;
      target && target !== this;
      target = target.parentNode
    ) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "minimog:check";
  let storage;
  if (type === "session") {
    storage = window.sessionStorage;
  }
  if (type === "local") {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

const moneyFormat = "${{amount}}";
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function intersecting(options) {
  var threshold = options.threshold ? options.threshold : 0;
  var observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: "0px 0px " + threshold + "px 0px" }
  );
  observer.observe(options.element);
}

class AnimateComponent extends HTMLElement {
  constructor() {
    super();

    intersecting({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    this.setAttribute("is-visible", true);
  }
}
customElements.define("animate-component", AnimateComponent);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia(container = document) {
  container.querySelectorAll(".js-youtube").forEach((video) => {
    if (!video.classList.contains("video-playsinline")) {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    }
  });
  container.querySelectorAll(".js-vimeo").forEach((video) => {
    if (!video.classList.contains("video-playsinline")) {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  });
  container.querySelectorAll("video").forEach((video) => {
    if (!video.classList.contains("video-playsinline")) {
      video.pause();
    }
  });
  container.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function cookiesEnabled() {
  let cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled) {
    document.cookie = "testcookie";
    cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
  }
  return cookieEnabled;
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getSrcset(src, sizes = ["360", "533", "720", "940", "1066"]) {
  sizes = sizes.map((size) => {
    return `${getSizedImageUrl(src, size + "x")} ${size}w`;
  });
  return sizes.join(", ");
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, "");
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === "master") {
    return removeProtocol(src);
  }

  const match = src.match(
    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i
  );

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];

    return removeProtocol(`${prefix[0]}_${size}${suffix}`);
  } else {
    return null;
  }
}

function getBaseUnit(variant) {
  if (!variant) {
    return;
  }

  if (
    !variant.unit_price_measurement ||
    !variant.unit_price_measurement.reference_value
  ) {
    return;
  }

  return variant.unit_price_measurement.reference_value === 1
    ? variant.unit_price_measurement.reference_unit
    : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.money_format = "${{amount}}";
Shopify.trademarkClass = function(symbols = [], tagName = 'span', className = 'trademark') {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
  const textNodes = [];

  let node;
  while ((node = walker.nextNode())) {
    const parent = node.parentNode;

    // Skip if inside trademark wrapper or inside a <script> tag
    if (
      parent.closest(`.${className}`) ||
      parent.closest('script')
    ) {
      continue;
    }

    if (symbols.some(symbol => node.nodeValue.includes(symbol))) {
      textNodes.push(node);
    }
  }

  textNodes.forEach(textNode => {
    const fragment = document.createDocumentFragment();
    let remainingText = textNode.nodeValue;

    while (remainingText.length > 0) {
      let nextSymbolIndex = Infinity;
      let nextSymbol = null;

      for (const symbol of symbols) {
        const index = remainingText.indexOf(symbol);
        if (index !== -1 && index < nextSymbolIndex) {
          nextSymbolIndex = index;
          nextSymbol = symbol;
        }
      }

      if (nextSymbol === null) {
        fragment.appendChild(document.createTextNode(remainingText));
        break;
      }

      if (nextSymbolIndex > 0) {
        fragment.appendChild(document.createTextNode(remainingText.slice(0, nextSymbolIndex)));
      }

      const wrapper = document.createElement(tagName);
      wrapper.className = className;
      wrapper.textContent = nextSymbol;
      fragment.appendChild(wrapper);

      remainingText = remainingText.slice(nextSymbolIndex + nextSymbol.length);
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  });
};



Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }
  connectedCallback() {
    const { sliderColumns, enableSlider } = this.dataset;
    if(this.classList.contains('mbl-slider') && window.innerWidth < 768){
       this.initSlider();
    }
    
  //     // Update data-slider-options based on screen size
  // const sliderOptions = this.dataset.sliderOptions;
  // if (sliderOptions) {
  //   const parsed = JSON.parse(sliderOptions);
  //   parsed.groupCells = window.innerWidth < 768 ? 1 : 5;
  //   this.dataset.sliderOptions = JSON.stringify(parsed);
  // }
    if (enableSlider !== "true") return;
    if (this.classList.contains("f-recently-viewed-flickity")) {
      this.initSlider();
    } else if (this.childElementCount > parseInt(sliderColumns)) {
      this.initSlider();
    } else if (this.childElementCount <= parseInt(sliderColumns)) {
      // Fix slider hidden.
      this.classList.remove("md:flickity-enable");
    }
  }
  initSlider() {
    this.slider = new window.FoxTheme.Slider(this);
    if(this.classList.contains('featured-collection')){
    var progressBar = this.nextElementSibling.firstElementChild;
      //  this.slider.instance.on("scroll", (progress) => {
      //     console.log('slider scroll',progress)
      // });
      const totalSlides = this.slider.container.querySelectorAll('.f-column').length 
      progressBar.style.width = '10%';
      this.slider.instance.on("change", (progress)=>{
        // console.log('slider',progress)
            progress = ((progress + 1) / totalSlides) * 100;
            progressBar.style.width = progress + "%";
         
      });
    }
    // const flkty = this.slider.instance;
    // const visibleSlides = parseInt(this.dataset.sliderColumns) || 5;
    // const maxIndex = flkty.slides.length - visibleSlides;
     
    // const updateNavButtons = (index) => {
    //   const nextBtn = flkty.nextButton;
    //   const prevBtn = flkty.previousButton;
     
    //   if (nextBtn) {
    //     nextBtn[ index >= maxIndex ? 'disable' : 'enable' ]();
    //   }
    //   if (prevBtn) {
    //     prevBtn[ index <= 0 ? 'disable' : 'enable' ]();
    //   }
    // };
     
    // // Initial update
    // updateNavButtons(flkty.selectedIndex);
     
    // // On arrow click
    // flkty.on("change", updateNavButtons);
     
    // // On drag settle
    // flkty.on("settle", () => {
    //   updateNavButtons(flkty.selectedIndex);
    //   if (flkty.selectedIndex > maxIndex) {
    //     flkty.select(maxIndex, false, true); // Prevent dragging too far
    //   }
    // });

    
     // New: Disable Next Button When at/near the end
  const updateNavButtonState = () => {
    if (!this.slider || !this.slider.instance) return;
    // Get the selected index and total number of cells
    const sliderElement = this.slider?.container;
    const columnsVisible = parseInt(sliderElement?.getAttribute('data-slider-columns')) || 1;
    // console.log("columnsVisible",this.slider.container)
    const selectedIndex = this.slider.instance.selectedIndex;
    const totalCells = this.slider.instance.cells?.length;
    
    // Obtain the Next button element.
    // Flickity typically appends the buttons as direct children of the instance.element.
    const nextButton = this.slider.instance.element.querySelector('.flickity-button.next');
    
    if (nextButton) {
      // If selected index is at or beyond the last cell, disable the button.
      // You can adjust the condition if you consider "near the end" differently.
      if (selectedIndex >= totalCells - columnsVisible) {
        nextButton.setAttribute('disabled', true);
        nextButton.classList.add('disabled');
      } else {
        nextButton.removeAttribute('disabled');
        nextButton.classList.remove('disabled');
      }
    }
  };
  
  // Bind updateNavButtonState to the 'select' event so it runs on each slide change.
  if (this.slider && this.slider.instance && this.classList.contains('featured-collection')) {
    this.slider.instance.on("select", updateNavButtonState);
    // Run initially to set the correct state.
    updateNavButtonState();
    const visibleSlides = parseInt(this.dataset.sliderColumns) || 5
    const maxIndex = this.slider.instance.slides.length - visibleSlides;
    this.slider.instance.on("settle", () => {
      if (this.slider.instance.selectedIndex > maxIndex) {
        // this.slider.instance.select(maxIndex, false, true); // Prevent dragging too far
      }
      updateNavButtonState()
    });
  }
 
    this.disablePointerMove = this.dataset.disablePointerMove || true;
    this.paginateCounterWrapper = this.querySelector(".flickity-page-counter");
    if (
      this.slider &&
      this.slider.instance &&
      this.dataset.disablePointerMove !== "false"
    ) {
      this.classList.remove('no-slider')
      this.classList.add("f-flickity-loaded");
      this.slider.instance.on("pointerMove", () => {
        this.classList.add("is-pointer-move");
      });
      this.slider.instance.on("pointerUp", () => {
        this.classList.remove("is-pointer-move");
      });
    }

    // Handle page counter
    if (this.slider && this.slider.instance && this.paginateCounterWrapper) {
      if (this.classList.contains("md:flickity-enable")) {
        this.paginateCounterWrapper.classList.remove("md:hidden");
        this.paginateCounterWrapper.classList.add("md:inline-flex", "hidden");
      } else {
        this.paginateCounterWrapper.classList.remove("hidden");
        this.paginateCounterWrapper.classList.add("inline-flex");
      }

      this.slider.instance.on("change", this.handlePaginateCounter.bind(this));
    }
    
    if (this.slider && this.slider.instance) {
      this.initialized = true;
      window.onresize = () => {
        const flickityViewPort = this.querySelector(".flickity-viewport");
        if (flickityViewPort) flickityViewPort.style.height = null;
        this.update();
      };
      // Fix media slider not init on Safari
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    }

    if (
      this.classList.contains("f-recently-viewed-flickity") &&
      this.childElementCount <= parseInt(this.dataset.sliderColumns)
    ) {
      this.classList.remove("md:flickity-enable");
    }
  }

  update() {
    if (this.slider && this.slider.instance) {
      this.slider.instance.resize();
    }
  }

  destroy() {
    if (typeof this.slider.instance === "object") {
      this.slider.instance.destroy();
      this.classList.add("flickity-destroyed");
      this.slider.instance.off("pointerMove");
      this.slider.instance.off("pointerUp");
    }
  }
  select(index, isWrapped = false, isInstant = false) {
    this.slider && this.slider.instance.select(index, isWrapped, isInstant);
  }
  toggleFade(isFade = false) {
    const method = isFade ? "add" : "remove";
    this.slider.instance.options.fade = isFade;
    this.classList[method]("is-fade");
    this.update();
  }
  handlePaginateCounter(index) {
    const sliderCounterCurrent = this.querySelector(
      ".flickity-counter--current"
    );
    if (sliderCounterCurrent) {
      sliderCounterCurrent.textContent = index + 1;
    }
  }
}
customElements.define("flickity-component", SliderComponent);
class PressNavComponent extends SliderComponent {
  constructor() {
    super();

    document.addEventListener("matchMobile", () =>
      this.slider.instance.resize()
    );
    document.addEventListener("unmatchMobile", () =>
      this.slider.instance.resize()
    );
  }
}
customElements.define("press-nav-component", PressNavComponent);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const autoplay = this.dataset.autoplay === "true";
    if (poster) {
      poster.addEventListener("click", this.loadContent.bind(this));
    } else {
      this.addObserver();
    }

    if (autoplay) {
      this.addObserver();
    }
  }

  addObserver() {
    if ("IntersectionObserver" in window === false) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadContent(false, false, "observer");
            observer.unobserve(this);
          }
        });
      },
      { rootMargin: "0px 0px 0px 0px" }
    );

    observer.observe(this);
  }

  loadContent(focus = true, pause = false, loadTrigger = "click") {
    document.querySelector('.mobile-only.f-video__bg video').play()
    if (pause) window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      this.loadTrigger = loadTrigger;
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      const isProductCard =
        deferredElement && deferredElement.closest(".product-card");
      if (isProductCard || deferredElement.tagName === "VIDEO")
        deferredElement.play();
      if (focus) deferredElement.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeEvent = new Event("close");
    this.openEvent = new Event("open");

    this.querySelector('[id^="ModalClose-"]') &&
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this)
      );
    this.addEventListener("keyup", (e) => {
      if (e.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        // if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }

    this.scrollbarWidth = getScrollbarWidth();
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    if (!this.hasAttribute("data-no-append")) {
      document.body.appendChild(this);
    }
  }

  show(opener) {
    const popup = this.querySelector(".template-popup");
    this.openedBy = opener;
    document.body.classList.add("prevent-scroll");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    this.dispatchEvent(this.openEvent);
    document.body.style.paddingRight = this.scrollbarWidth + "px";
  }

  hide() {
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    this.setAttribute("closing", "true");
    setTimeout(() => {
      this.removeAttribute("open");
      this.removeAttribute("closing");
      document.body.classList.remove("prevent-scroll");
      this.dispatchEvent(this.closeEvent);
      document.body.style.paddingRight = "";
    }, 300);
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.dataset.modal);
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class QuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;
  quantityBoundriesUnsubscriber = undefined;
  quantityRulesUnsubscriber = undefined;

  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  get productId() {
    return this.getAttribute("data-product-id");
  }

  get input() {
    return this.querySelector("input");
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    // Prevent multiple initialization
    if (this.hasAttribute("initialized")) return;
    this.setAttribute("initialized", "");

    this.abortController = new AbortController();

    this.buttons = Array.from(this.querySelectorAll("button"));
    this.changeEvent = new Event("change", { bubbles: true });

    // Move event listeners to use the AbortController signal
    this.input.addEventListener("change", this.onInputChange.bind(this), {
      signal: this.abortController.signal,
    });

    this.input.addEventListener(
      "focus",
      () => setTimeout(() => this.input.select()),
      { signal: this.abortController.signal }
    );

    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this), {
        signal: this.abortController.signal,
      });
    });

    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
    this.quantityBoundriesUnsubscriber = FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.quantityBoundries,
      this.setQuantityBoundries.bind(this)
    );
    this.quantityRulesUnsubscriber = FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.quantityRules,
      this.updateQuantityRules.bind(this)
    );
  }

  disconnectedCallback() {
    // Remove the initialized attribute when component is disconnected
    this.removeAttribute("initialized");

    this.abortController.abort();

    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.quantityBoundriesUnsubscriber) {
      this.quantityBoundriesUnsubscriber();
    }
    if (this.quantityRulesUnsubscriber) {
      this.quantityRulesUnsubscriber();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === "plus") {
      if (
        parseInt(this.input.getAttribute("data-min")) >
          parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.getAttribute("data-min");
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.getAttribute("data-min") === previousValue &&
      event.currentTarget.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  onInputChange() {
    if (this.input.value === "") {
      this.input.value = parseInt(this.input.min);
    }
    this.validateQtyRules();
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector('button[name="minus"]');
      if (buttonMinus)
        buttonMinus.toggleAttribute(
          "disabled",
          parseInt(value) <= parseInt(this.input.min)
        );
    }
    if (this.input.max) {
      const buttonPlus = this.querySelector('button[name="plus"]');
      if (buttonPlus)
        buttonPlus.toggleAttribute(
          "disabled",
          parseInt(value) >= parseInt(this.input.max)
        );
    }
  }

  updateQuantityRules({ data: { sectionId, productId, parsedHTML } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;

    const selectors = [
      ".quantity__input",
      ".quantity__rules",
      ".quantity__label",
    ];
    const quantityFormUpdated = parsedHTML.getElementById(
      `QuantityForm-${sectionId}`
    );
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === ".quantity__input") {
        const attributes = [
          "data-cart-quantity",
          "data-min",
          "data-max",
          "step",
        ];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries({ data: { sectionId, productId } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;

    const data = {
      cartQuantity: this.input.hasAttribute("data-cart-quantity")
        ? parseInt(this.input.getAttribute("data-cart-quantity"))
        : 0,
      min: this.input.hasAttribute("data-min")
        ? parseInt(this.input.getAttribute("data-min"))
        : 1,
      max: this.input.hasAttribute("data-max")
        ? parseInt(this.input.getAttribute("data-max"))
        : null,
      step: this.input.hasAttribute("step")
        ? parseInt(this.input.getAttribute("step"))
        : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute("max");
    }
    this.input.value = min;

    FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityUpdate, undefined);
  }

  reset() {
    this.input.value = this.input.defaultValue;
  }
}

customElements.define("quantity-input", QuantityInput);

class Drawer extends HTMLElement {
  constructor() {
    super();
    this.closeEvent = new Event("close");
    this.openEvent = new Event("open");

    this.opened = false;

    this.querySelector('[id^="DrawerClose-"]') &&
      this.querySelector('[id^="DrawerClose-"]').addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          this.closeDrawer();
        }
      );
    this.addEventListener("keyup", (e) => {
      if (e.code.toUpperCase() === "ESCAPE") this.closeDrawer();
    });

    this.elementToFocus =
      this.querySelector('[tabindex="-1"]') ||
      this.querySelector('input:not([type="hidden"])');
    if (this.dataset.elementToFocus)
      this.elementToFocus = this.querySelector(this.dataset.elementToFocus);
    // this.scrollbarWidth = getScrollbarWidth();
  }

  connectedCallback() {
    if (this.moved) return;
    const canMove = this.dataset.canMove;
    // console.log('canMove',this,canMove)
    if (!canMove || canMove !== "false") {
      this.moved = true;
      if(this.classList.contains('f-drawer-search')){
        // console.log('this',this.querySelector('.f-drawer__scroller'))
        // this.querySelector('.f-drawer__scroller').classList.add('hidden')
        // document.querySelector('.site-header').appendChild(this)
        // document.querySelector('.site-header__wrapper').appendChild(this)
        // console.log('this')      
      }else{
        document.body.appendChild(this);
      }
    }
  }

  isOpen() {
    return this.hasAttribute("open");
  }

  onBodyClick(e) {
    if (e.target.classList.contains("f-drawer__overlay"))
      this.closeDrawer(false);
  }

  openDrawer(opener) {
    if(this.classList.contains('f-drawer-mobile-nav')){
      document.body.classList.add('menu-open')
    }
    this.openedBy = opener;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("prevent-scroll");
    this.setAttribute("open", "");

    trapFocus(this, this.elementToFocus);
    this.dispatchEvent(this.openEvent);
    // document.body.style.paddingRight = this.scrollbarWidth + "px";
  }

  closeDrawer(focusToggle = true) {
    if (focusToggle) removeTrapFocus(this.openedBy);
    if(this.classList.contains('f-drawer-mobile-nav')){
      document.body.classList.remove('menu-open')
    }
    this.removeAttribute("open");
    this.querySelectorAll('[data-collapsible-parent]').forEach((parent)=>{
      parent.classList.remove('active-list');
      parent.classList.remove('active-sub-list')
    })
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("prevent-scroll");
    this.dispatchEvent(this.closeEvent);
    // document.body.style.paddingRight = "";
  }
}

customElements.define("drawer-component", Drawer);

customElements.define(
  "drawer-opener",
  class DrawerOpener extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.disabled === "true") return;
      const button =
        this.querySelector("button") || this.querySelector("[data-opener]");
      if (!button) return;
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const drawer = document.querySelector(this.dataset.drawer);
        if (drawer) drawer.openDrawer(button);
      });
    }
  }
);

customElements.define(
  "drawer-closer",
  class DrawerCloser extends HTMLElement {
    constructor() {
      super();
      const drawer = this.closest("drawer-component");

      if (drawer) {
        this.addEventListener("click", (e) => {
          e.preventDefault();
          drawer.closeDrawer();
        });
         window.addEventListener(PUB_SUB_EVENTS.cartClose, () => {
          drawer.closeDrawer();
        });
      }
    }
  }
);

customElements.define(
  "cart-note",
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        "change",
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${FoxThemeSettings.routes.cart_update_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: `application/json`,
            },
            ...{ body },
          });
        }, 300)
      );
      this.collapsible = this.querySelector("collapsible-tab");
      this.querySelector(".btn-cancel").addEventListener(
        "click",
        this.handleClose.bind(this)
      );
    }

    handleClose(e) {
      e.preventDefault();
      if (this.collapsible) this.collapsible.close();
    }
  }
);

customElements.define(
  "cart-delivery-time",
  class CartDeliveryTime extends HTMLElement {
    constructor() {
      super();
      this.collapsible = this.querySelector("collapsible-tab");
      this.deliveryTimeElm = this.querySelector(
        "[name='attributes[Delivery time]']"
      );
      this.errorWrapper = this.querySelector(".f-cart-block-message-error");
      this.deliveryCodeKey = "zest-delivery-code";
      this.querySelector(".btn-cancel").addEventListener(
        "click",
        this.handleClose.bind(this)
      );
      this.querySelector(".btn-save").addEventListener(
        "click",
        this.handleSave.bind(this)
      );
      const today = new Date().toISOString().slice(0, 16);
      if (this.deliveryTimeElm) this.deliveryTimeElm.min = today;
    }
    handleSave(e) {
      e.preventDefault();
      const time = this.deliveryTimeElm.value;
      const currentTime = Date.parse(time);
      if (currentTime > Date.now()) {
        localStorage.setItem(this.deliveryCodeKey, time);
        const body = JSON.stringify({ attributes: { "Delivery time": time } });
        fetch(`${FoxThemeSettings.routes.cart_update_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
          },
          ...{ body },
        });
        this.handleClose(e);
      } else if (time == "") {
        localStorage.removeItem(this.deliveryCodeKey);
        window.FoxTheme.Notification.show({
          target: this.errorWrapper,
          method: "appendChild",
          type: "warning",
          message: window.FoxThemeStrings.noSelectDeliveryTime,
        });
      } else {
        localStorage.removeItem(this.deliveryCodeKey);
        window.FoxTheme.Notification.show({
          target: this.errorWrapper,
          method: "appendChild",
          type: "warning",
          message: window.FoxThemeStrings.invalidDeliveryTime,
        });
      }
    }
    handleClose(e) {
      e.preventDefault();
      if (this.collapsible) this.collapsible.close();
    }
  }
);

customElements.define(
  "product-modal",
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = this.querySelector("flickity-component");
      this.mediaContent = this.querySelector(".media-modal__content");
    }

    hide() {
      super.hide();
      this.mediaContent.setAttribute("data-media-loading", "");
    }

    show(opener) {
      super.show(opener);
      if (this.slider) {
        setTimeout(() => {
          this.slider.update();
          this.showActiveMedia();
          this.slider.focus();
        }, 300);
      }
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
      );
      if (activeMedia) {
        const activeIndex = Number(activeMedia.dataset.index);
        this.slider.select(activeIndex, false, true);
        this.mediaContent.removeAttribute("data-media-loading");
      }
    }
  }
);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }

  open() {
    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", true);
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      // console.log('url',this.dataset.url)
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = generateDomFromString(text);
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            __reInitTooltip(this);
            Shopify.trademarkClass(['®', '™'])
          }

          if (html.querySelector(".product-card")) {
            this.classList.add("product-recommendations--loaded");
          } else {
            this.classList.add("f-hidden");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class FProgressBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      this.style.setProperty(
        "--progress-bar-width",
        `${(quantity * 100) / 50}%`
      );
    });
  }
}
customElements.define("f-progress-bar", FProgressBar);
class VideoComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.parentSelector = this.dataset.parent || ".f-video-wrapper";
    this.parent = this.closest(this.parentSelector);

    switch (this.dataset.type) {
      case "youtube":
        this.initYoutubeVideo();
        break;

      case "vimeo":
        this.initVimeoVideo();
        break;

      case "mp4":
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector("video");

    if (player) {
      const promise = player.play();

      // Edge does not return a promise (video still plays)
      if (typeof promise !== "undefined") {
        promise
          .then(function () {
            // playback normal
          })
          .catch(function () {
            player.setAttribute("controls", "");
          });
      }
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src =
        videoType === "youtube"
          ? "//www.youtube.com/iframe_api"
          : "//player.vimeo.com/api/player.js";
    });
  }

  setAsLoading() {
    this.parent.setAttribute("loading", true);
  }

  setAsLoaded() {
    this.parent.removeAttribute("loading");
    this.parent.setAttribute("loaded", true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;
    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement("div");
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: false,
              fs: 0,
              rel: 0,
              height: "100%",
              width: "100%",
              iv_load_policy: 3,
              html5: 1,
              loop: 1,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1,
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this),
            },
          });
          clearInterval(playerInterval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector("iframe"); // iframe once YT loads
    this.iframe.setAttribute("tabindex", "-1");

    if (typeof this.player.mute === "function") this.player.mute();
    if (typeof this.player.playVideo === "function") this.player.playVideo();

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.youtubePlay();
          } else {
            this.youtubePause();
          }
        });
      },
      { rootMargin: "0px 0px 50px 0px" }
    );

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          // this.closest('.banner').classList.add('video-interactable');
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (this.player && typeof this.player.playVideo === "function") {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (this.player && typeof this.player.pauseVideo === "function") {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: false,
          controls: false,
          loop: true,
          height: "100%",
          width: "100%",
        });
        this.player.ready().then(this.onVimeoReady.bind(this));
        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector("iframe");
    this.iframe.setAttribute("tabindex", "-1");

    this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.vimeoPlay();
          } else {
            this.vimeoPause();
          }
        });
      },
      { rootMargin: "0px 0px 50px 0px" }
    );

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (this.player && typeof this.player.play === "function") {
      this.player.play();
    }
  }

  vimeoPause() {
    if (this.player && typeof this.player.pause === "function") {
      this.player.pause();
    }
  }
}
customElements.define("video-component", VideoComponent);

if (!customElements.get("f-scrolling-promotion")) {
  class FScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.promotion = this.querySelector(".f-promotion");
      this.init();
    }

    init() {
      console.log('this anima',this,this.childElementCount)
      this.querySelectorAll('.f-image').forEach((item) => {
      item.classList.remove('before-load');
    });

      if (this.childElementCount === 1) {
        this.promotion.classList.add("f-promotion--animated");

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove("f-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("f-scrolling-promotion--paused");
    }
  }

  customElements.define("f-scrolling-promotion", FScrollingPromotion);
}

class ImageComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.active = false;
    this.button = this.querySelector("button");
    this.horizontal = this.dataset.layout === "horizontal";
    this.customContent = this.closest('[data-section-type="f-custom-content"]');

    if (this.hasAttribute("data-animation")) {
      intersecting({
        element: this.querySelector(".f-image-comparison-slider__animation"),
        callback: this.animation.bind(this),
        threshold: 0,
      });
    } else {
      this.init();
    }
  }

  init() {
    this.button.addEventListener(
      "touchstart",
      this.handleTouchStart.bind(this),
      { passive: true }
    );
    document.body.addEventListener("touchend", this.handleTouchEnd.bind(this));
    document.body.addEventListener(
      "touchmove",
      this.handleMouseMove.bind(this)
    );

    this.button.addEventListener("mousedown", this.handleTouchStart.bind(this));
    document.body.addEventListener("mouseup", this.handleTouchEnd.bind(this));
    document.body.addEventListener(
      "mousemove",
      this.handleMouseMove.bind(this)
    );
  }

  animation() {
    const animation = this.hasAttribute("data-animation");
    if (!animation) return;
    this.setAttribute("is-visible", "");
    this.classList.add("f-animating");
    setTimeout(() => {
      this.classList.remove("f-animating");
    }, 1e3);
    this.init();
  }

  handleTouchStart() {
    const scrollBarWidth = getScrollbarWidth();
    this.customContent && this.customContent.classList.remove("relative");
    document.body.style.setProperty("padding-right", `${scrollBarWidth}px`);
    document.body.style.overflow = "hidden";
    this.active = true;
    this.classList.add("dragging");
  }

  handleTouchEnd() {
    document.body.style.removeProperty("padding-right");
    this.customContent && this.customContent.classList.add("relative");
    this.active = false;
    this.classList.remove("dragging");
    document.body.style.overflow = "";
  }

  handleMouseMove(e) {
    if (!this.active) return;

    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
      ? event.pageX - this.offsetLeft
      : event.pageY - this.offsetTop;

    this.handleChange(x);
  }

  handleChange(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;

    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, Math.min(x, max));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty("--percent", mousePercent + "%");
  }
}
customElements.define("f-image-comparison-slider", ImageComparisonSlider);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // Save product Id
    if (isStorageSupported("local")) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = "zest-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");

      // Check current product already exists, if not push to array
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // Save to localStorage
      window.localStorage.setItem(
        cookieName,
        JSON.stringify(items.slice(0, 20))
      );
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);

class HighlightText extends HTMLElement {
  constructor() {
    super();
    intersecting({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }
  init() {
    this.classList.add("animate");
  }
}
customElements.define("highlight-text", HighlightText, { extends: "em" });

if (!customElements.get("show-more-button")) {
  customElements.define(
    "show-more-button",
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector("button");
        button.addEventListener("click", (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target
            .closest(".parent-display")
            .querySelector(".show-more-item");
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains("hidden") &&
            nextElementToFocus.querySelector("input")
          ) {
            nextElementToFocus.querySelector("input").focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target
          .closest('[id^="Show-More-"]')
          .closest(".parent-display");
        const parentWrap = parentDisplay.querySelector(".parent-wrap");
        this.querySelectorAll(".label-text").forEach((element) =>
          element.classList.toggle("hidden")
        );
        parentDisplay
          .querySelectorAll(".show-more-item")
          .forEach((item) => item.classList.toggle("hidden"));
        if (!this.querySelector(".label-show-less")) {
          this.classList.add("hidden");
        }
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("div[data-option-name='Size'] input[type='radio']:not(.default)").forEach(radio => {
        radio.checked = false;
    });
});


//append icon block to Product descrioption tab on page load
  document.addEventListener("DOMContentLoaded", function () {
    // Check if body has the class "template-product"
    if (document.body.classList.contains("template-product")) {
      // Get all elements with class ".block-icon"
      const iconBlocks = document.querySelectorAll(".block-icon");

      // Check if any ".block-icon" elements exist
      if (iconBlocks.length > 0) {
        const accordionInner = document.querySelector(
          ".product__accordion__inner"
        );

        // Check if the target element ".product__accordion__inner" exists
        if (accordionInner) {
          iconBlocks.forEach((block) => {
            // Clone the block
            // const clonedBlock = block.cloneNode(true);
            // Append cloned block to ".product__accordion__inner"
            // accordionInner.appendChild(clonedBlock);
            // Remove the original block from its original position
            // block.remove();
          });
        }
      }
    }

    /* PLP color swatch click handler*/
    document.body.addEventListener("mouseenter", function (e) {
        var colorInput = e.target.closest(".has-custom-swatch");
        if (!colorInput) return; // Exit if the hovered element isn't a swatch
    
        var parent = colorInput.closest(".product-card");
    
        var selectors = {
            "productImage": "[data-product-image]",
            "productImageHover": "[data-product-image-hover]"
        };
    
        parent.querySelectorAll(".swatch__button").forEach(function (swatch) {
            swatch.classList.remove("active-swatch");
        });
    
        colorInput.parentElement.classList.add("active-swatch");
        updateProductDetails(parent, colorInput, selectors);
    }, true); // Use capture phase for better delegation

  });

let lastHandle = null;
let currentFetchId = 0;

// async function updateProductDetails(parent, colorInput, selectors) {
//   const handle = colorInput.dataset.handle;

//   // Skip if same handle already updated
//   if (handle === lastHandle) return;
//   lastHandle = handle;

//   const fetchId = ++currentFetchId;

//   try {
//     const response = await fetch(`https://tavi-new.myshopify.com/products/${handle}?view=color-change-product`);
//     const html = await response.text();

//     // Skip outdated fetches (in case user hovers quickly between swatches)
//     if (fetchId !== currentFetchId) return;

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, 'text/html');

//     const productWrapper = doc.querySelector('.product-card');
//     console.log('card', productWrapper);

//     if (productWrapper) {
//       parent.innerHTML = productWrapper.innerHTML;
//     } else {
//       console.warn('.product-card not found in fetched HTML.');
//     }

//   } catch (error) {
//     console.error('Error fetching HTML:', error);
//   }
// }

// Color swatch hover logic
// document.body.addEventListener("mouseenter", function (e) {
//   const colorInput = e.target.closest(".has-custom-swatch");
//   if (!colorInput) return;

//   const parent = colorInput.closest(".product-card");

//   const selectors = {
//     productImage: "[data-product-image]",
//     productImageHover: "[data-product-image-hover]"
//   };

//   parent.querySelectorAll(".swatch__button").forEach(function (swatch) {
//     swatch.classList.remove("active-swatch");
//   });

//   colorInput.parentElement.classList.add("active-swatch");

//   updateProductDetails(parent, colorInput, selectors);

// }, true); // Capture phase helps on deep delegation


function updateProductDetails(parent, colorInput, selectors, themeCurrency) {
  const {
    image1, image2, prodid: productId, available, custombadge, title, price, sale, saving,
    handle, url, swatch: color_name, saleHtml,extraDisc,disc,static
  } = colorInput.dataset;
  if(document.body.classList.contains('template-collection')){
    fetch('/products/' + handle + '?view=image')
    .then((response) => response.text())
    .then((html) => {
      // 1. Parse the response HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // 2. Get all .swiper-slide elements from .swiper-data
      const newSlides = doc.querySelectorAll('.swiper-data .swiper-slide');

      // 3. Find existing swiper wrapper in your current page
      const swiperWrapper = parent.querySelector('.swiper-wrapper');
      if (!swiperWrapper) {
        return;
      }
      swiperWrapper.innerHTML = '';
      newSlides.forEach(slide => {
        swiperWrapper.appendChild(slide.cloneNode(true));
      });
      const swiperContainer = parent.querySelector('[data-mobile-swiper]');
      setTimeout(()=>{
        initSingleSwiper(swiperContainer);
      },200)
    })
  }

  const priceInt = parseInt(price), salePriceInt = parseInt(sale), isAvailable = JSON.parse(available);
  parent.querySelectorAll('.product-quickadd-container').forEach(el => el.classList.add('hidden'));
  parent.querySelector('.product-color-selected').innerText = color_name;

  const targetItem = parent.querySelector(`[data-prodid='${productId}']`);
  if (targetItem) targetItem.classList.remove('hidden');

  const firstImg = parent.querySelector(`${selectors.productImage} img`);
  const secondImg = parent.querySelector(`${selectors.productImageHover} img`);
  const mainUrl = parent.querySelector(".product-card__link");
  const mainPrice = parent.querySelector(".f-price");
  const mainTitle = parent.querySelector(".product-grid-item__title");
  const saveBadge = parent.querySelector('.f-badge--sale');
  const badgeWrapper = parent.querySelector(".product-card__image-wrapper");
  const quickviewBtn = parent.querySelector(".product-card__quickview") || parent.querySelector(".product-card__atc");
  const extraDiscEle = parent.querySelector(".price-detail .detail");

  quickviewBtn?.setAttribute('data-product-quickview', handle);
  mainUrl?.setAttribute("href", url);
  document.querySelectorAll('.rest-count').forEach(btn => btn.setAttribute("href", url));

  if (image1 && firstImg) {
    firstImg.setAttribute("srcset", image1);
    if (secondImg && image2) {
      secondImg.setAttribute("srcset", image2);
      parent.classList.remove('has-no-img');
    } else {
      secondImg?.setAttribute("srcset", '');
      parent.classList.add('has-no-img');
    }
  }
  const discountText = disc !== undefined && static == 'false' ? ` Price After ${disc} Off` : "";
  const extraDiscountText = extraDisc
  const badges = custombadge.split(",").map(b => `<span class="f-badge f-badge--custom">${b.trim()}</span>`).join("");
  var priceHtml = `<div class="f-price__sale">
    <span class="visually-hidden visually-hidden--inline">Sale price</span>
    <span class="f-price-item f-price-item--sale">${Shopify.formatMoney(priceInt, window.FoxThemeSettings.money_format)}<span class="custom-txt">${discountText}</span></span>
    <span class="visually-hidden visually-hidden--inline">Regular price</span>
    <span><s class="f-price-item f-price-item--regular">${Shopify.formatMoney(salePriceInt, window.FoxThemeSettings.money_format)}</s></span></div>`;

 if(static != false && static != '' && static != 'false'){  
  priceHtml = `<div class="f-price__sale">
    <span class="visually-hidden visually-hidden--inline">Sale price</span>
    <span class="f-price-item f-price-item--sale">${Shopify.formatMoney(priceInt, window.FoxThemeSettings.money_format)}</span><span class="st-msg"></span>
    <span class="visually-hidden visually-hidden--inline">Regular price</span>
    <span class="rg_price"><s class="f-price-item f-price-item--regular">${Shopify.formatMoney(salePriceInt, window.FoxThemeSettings.money_format)}</s></span></div>`;
 }
  let allBadges = '';
  if (!isAvailable) allBadges += `<span class="f-badge f-badge--soldout" aria-hidden="true">Sold out</span>`;
  if (custombadge) allBadges += badges;

  if (!saveBadge && saleHtml) {
    const newSave = document.createElement("span");
    newSave.className = "f-badge f-badge--sale";
    newSave.innerText = saleHtml;
    // badgeWrapper.appendChild(newSave);
  } else if (saveBadge && saleHtml) {
    // saveBadge.classList.remove('custom-hidden');
    // saveBadge.innerText = saleHtml;
  } else if (saveBadge && !saleHtml) {
    saveBadge.classList.add('custom-hidden');
  } 
  if (salePriceInt > priceInt) {
    mainPrice.classList.add('f-price--on-sale');    
    if (typeof extraDisc !== 'undefined' && (static == false || static == 'false')) {
      const $priceHtml = $(priceHtml); // convert string to jQuery object
      $priceHtml.find('.custom-txt').text(` Extra ${extraDisc} in the bag`);
      priceHtml = $priceHtml.prop('outerHTML'); // convert it back to HTML string if needed
    }
    else if(static != false && static != '' && static != 'false'){      
      const $priceHtml = $(priceHtml); // convert string to jQuery object
      $priceHtml.find('.st-msg').text(static);
      priceHtml = $priceHtml.prop('outerHTML'); // convert it back to HTML string if needed
    }
    mainPrice.innerHTML = priceHtml;
  } else {
    mainPrice.classList.remove('f-price--on-sale');
    mainPrice.innerHTML = `<div class="f-price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="f-price-item f-price-item--regular">${Shopify.formatMoney(priceInt, window.FoxThemeSettings.money_format)}</span></div>`;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  Shopify.trademarkClass(['®', '™'])
   document.addEventListener("click", (event) => {
    if (event.target.matches(".dropdown-button-custom")) {
      event.preventDefault();
      const ul = event.target.nextElementSibling.nextElementSibling;
      if (ul && ul.tagName === "UL") {
        ul.classList.toggle("hidden"); // Toggle visibility
      }
    }
     if (event.target.matches(".dropdown-button")) {
      event.preventDefault();
      const ul = event.target.nextElementSibling;
      if (ul && ul.tagName === "UL") {
        ul.classList.toggle("hidden"); // Toggle visibility
      }
    }
  });
  document.addEventListener('click', function(event) {
    const isClickInside = event.target.closest('.dropdown-button-custom, .dropdown-button, #SortByList');
    if (!isClickInside) {
     document.querySelectorAll('#SortByList').forEach((form)=>{
       form.classList.add('hidden')
     })
    }
  });


  
  // Get the current URL
  const urlParams = new URLSearchParams(window.location.search);
  
  // Check if sort_by=manual is in the URL
  if(urlParams.get("sort_by") != null || window.location.href.includes('/search')){
    document.querySelectorAll('.dropdown-button-custom').forEach((btn)=>{
      btn.classList.add('hidden');
    })
    document.querySelectorAll('.dropdown-button').forEach((btn)=>{
      btn.classList.remove('hidden');
    })
  }
  if (urlParams.get("sort_by") === "manual") {
       document.querySelector(".product-grid__header [data-facet-form] .custom-option").remove();
      // Find the option element where the value is "manual" and does not have the class "custom-option"
      document.querySelector('.product-grid__header [data-facet-form] option[value="manual"]:not(.custom-option)')?.setAttribute("selected", "selected");
  }
  document.querySelectorAll('.quick-add-btn').forEach((item)=>{
    item.addEventListener('click',()=>{
      var id = item.dataset.quickaddId;
      item.parentNode.parentNode.parentNode.querySelector('.quick-add-form input[name="id"]').value = id;
      var form = item.parentNode.parentNode.parentNode.querySelector('.quick-add-form');
      if(form){      
        const config = {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
        };
    
        const formData = new FormData(form);
        this.cartNotification = document.querySelector('cart-notification');
         formData.append("sections",'cart-drawer');
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
      
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {  
             window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          // $this.next().removeClass('loading');
        });
      }
    })
  })
  
  $('body').on('click','#ModalClose-QuickView',function(){
    const modal = document.getElementById("QuickView-Modal");
    const closeEvent = new Event("close");
    modal.dispatchEvent(closeEvent);    
    $('body').removeClass('prevent-scroll');
  })
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const filterBar = document.querySelector('.product-grid__header');
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  const sectionHeader = document.querySelector('.f-section-header');
  const plp_list = document.querySelector('.shopify-section .collection-list');
  
  function getOffsetHeight(el) {
    return el ? el.offsetHeight : 0;
  }

  if(filterBar){
    window.addEventListener('scroll', () => {
       if (/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          // Mobile device detected
         // alert("Mobile device");
        } 
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const headerOffset = getOffsetHeight(headerGroup) + getOffsetHeight(sectionHeader) +  getOffsetHeight(plp_list);
      
      if (currentScroll > headerOffset) {
        if (currentScroll > lastScrollTop) {
          // Scrolling down – hide filter bar
          filterBar.style.transform = 'translateY(-100%)';
        } else {
          // Scrolling up – show filter bar
          filterBar.style.transform = 'translateY(0)';
        }
      }
    
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
  }




})


$('.next-arrow').on('click', function () {
  const targetId = $(this).attr('data-target');
  $('.nav-menu').addClass('hidden'); // Hide all nav menus
  const targetMenu = $(`.nav-menu[data-id="${targetId}"]`);
  targetMenu.removeClass('hidden'); // Show the target menu

  const parentDrawer = $(this).closest('.nav-drawer__contents');
  parentDrawer.addClass('hidden'); // Hide the parent drawer
});



$('.close-btn').on('click', function() {
  const parentMenu = $(this).closest('.nav-menu');
  parentMenu.addClass('hidden');
  var get_attr = $(this).parent('.nav-menu').attr('data-id')
  $(`.next-arrow[data-target="${get_attr}"]`).closest('.nav-menu').removeClass('hidden');
  $(this).closest('.nav-drawer__contents').prev('.nav-drawer__contents').removeClass('hidden');
});
const config1 = {
    method: "POST",
    headers: {
      Accept: "application/javascript",
      "X-Requested-With": "XMLHttpRequest",
    },
  };
// var cntrData = {};
// try {
// if(document.querySelector('.f-product-form__submit')){
//     document.querySelector('.f-product-form__submit').addEventListener("click", function(){  
//       console.log('atc click')
//       cntrData = {'addtocart-TAVI':'button',};
//       if(cntrUpTag){
//       // console.log(cntrData,cntrUpTag)
//       cntrUpTag.track('cntrData', '1d53a7a971523251');
//       }
//   })
// }
 
//   if(document.querySelector('button[name="checkout"]')){
//     document.querySelector('button[name="checkout"]').addEventListener("click", function(){
//     cntrData = { 'checkout':'button',  };
//     if(cntrUpTag){
//       cntrUpTag.track('cntrData', '1d53a7a971523251');
//       // console.log(cntrData,cntrUpTag)
//     }
//   })
// }
  
// } catch (error) {
//   console.log('cntrtag error',error)
// }

document.body.addEventListener('click', function (e) {
  const btn = e.target.closest('.yotpo-sr-bottom-line-button');
  if (!btn) return;
 
  e.preventDefault(); // Optional: prevent default button behavior
 
  // Scroll to Yotpo main widget once it exists
  let attempts = 0;
  const maxAttempts = 10;
  const interval = setInterval(() => {
    const widget = document.querySelector('#yotpo-reviews-main-widget');
    if (widget || attempts >= maxAttempts) {
      clearInterval(interval);
      if (widget) {
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // console.warn('#yotpo-reviews-main-widget not found after retrying');
      }
    }
    attempts++;
  }, 200); // Retry every 200ms
});
 
document.body.addEventListener('click', function (e) {
  const target = e.target.closest('#yotpo-star-rating-reviews-summary');
  if (!target) return;
 
  e.preventDefault(); // Optional
 
  const summaryBtn = document.querySelector('button#yotpo-summary');
  if (summaryBtn) {
    summaryBtn.click();
  } else {
    // console.warn('button#yotpo-summary not found');
  }
});
const MOBILE_BREAKPOINT = 768;
const swiperSelector = '[data-mobile-swiper]';
const swiperClass = 'swiper-initialized';

// Common Swiper config
function getSwiperConfig(container) {
  return {
    slidesPerView: 1,
    loop: false,
    // spaceBetween:10,
    lazy: {
      loadOnTransitionStart: true,
      loadPrevNext: true
    },
    scrollbar: {
      el: container.querySelector('.swiper-scrollbar'),
      draggable: true,
    },
    on: {
      init: function () {
        const scrollbarEl = container.querySelector('.swiper-scrollbar');
        if (scrollbarEl) {
          scrollbarEl.style.opacity = '0';
          scrollbarEl.style.transition = 'opacity 0.3s ease';
        }
      },
      slideChangeTransitionStart: function () {
        const scrollbarEl = container.querySelector('.swiper-scrollbar');
        if (!scrollbarEl) return;
        scrollbarEl.style.opacity = '1';
        clearTimeout(scrollbarEl._hideTimeout);
        scrollbarEl._hideTimeout = setTimeout(() => {
          scrollbarEl.style.opacity = '0';
        }, 1000);
      }
    }
  };
}

// ✅ Initialize swiper for one container
let gestureDone = false;
function initSingleSwiper(container) {
  // Destroy old swiper if exists
  if (container.swiper) {
    container.swiper.destroy(true, true);
    container.swiper = null;
  }

  // Reset styles so Swiper doesn’t carry over wrong widths
  const wrapper = container.querySelector('.swiper-wrapper');
  if (wrapper) wrapper.removeAttribute('style');
  container.querySelectorAll('.swiper-slide').forEach(slide => {
    slide.removeAttribute('style');
  });

  // Init new swiper
  const swiper = new Swiper(container, getSwiperConfig(container));
  container.swiper = swiper;

  // ✅ Force Swiper to fully recalc (important if slide count changed)
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  swiper.slideTo(0, 0, false);

  // Optional: eager load all lazy images
  if (swiper.lazy && swiper.slides) {
    swiper.slides.forEach((slide, index) => {
      swiper.lazy.loadInSlide(index);
    });
  }
    //  Half-swipe gesture only on the first swiper & only once
   if (!gestureDone && document.querySelector(swiperSelector) === container) {
    gestureDone = true;

    const firstImg = container.querySelector('.swiper-slide img');
    if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', () => runGesture(swiper), { once: true });
    } else {
      runGesture(swiper);
    }
  }
}
function runGesture(swiper) {
  const distance = swiper.width * 0.5; // 30% peek
  setTimeout(() => {
    if (!swiper.destroyed) {
      swiper.setTransition(400);
      swiper.setTranslate(-distance);
    }
    setTimeout(() => {
      if (!swiper.destroyed) {
        swiper.setTransition(400);
        swiper.setTranslate(0);
      }
    }, 800);
  }, 400);
}



// ✅ On load → initialize all
function initAllSwipers() {
  if (window.innerWidth < MOBILE_BREAKPOINT) {
    document.querySelectorAll(swiperSelector).forEach(container => {
      initSingleSwiper(container);
    });
  } else {
    // Destroy all if viewport >= breakpoint
    document.querySelectorAll(swiperSelector).forEach(container => {
      if (container.swiper) {
        container.swiper.destroy(true, true);
        container.classList.remove(swiperClass);
      }
    });
  }
}



// Call on load and resize
window.addEventListener('load', initAllSwipers);
window.addEventListener('resize', () => {
  clearTimeout(window._swiperResizeTimer);
  window._swiperResizeTimer = setTimeout(initAllSwipers, 200);
});

document.addEventListener('rebind:mobile-swipers', initAllSwipers);
document.addEventListener("DOMContentLoaded", () => {
document.querySelectorAll(".mute-video").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    // Try to find the video near this button
    const video = btn.parentElement.querySelector("video");
    const mbl_video = btn.parentElement.querySelector('.mobile_video video');
    console.log('mbl_video',mbl_video,mbl_video.lengh)
    if (video) {
      if(mbl_video != undefined && window.innerWidth < 768){
        if (mbl_video.muted) {
            mbl_video.muted = false;
            document.querySelectorAll(".mute-video").forEach(el => {
              el.classList.add("muted-off");
              el.classList.remove("muted-on");
            });
          } else {
            mbl_video.muted = true;
            document.querySelectorAll(".mute-video").forEach(el => {
              el.classList.add("muted-on");
              el.classList.remove("muted-off");
            });
          }
      }
      else{
        if (video.muted) {
          video.muted = false;
          document.querySelectorAll(".mute-video").forEach(el => {
            el.classList.add("muted-off");
            el.classList.remove("muted-on");
          });
        } else {
          video.muted = true;
          document.querySelectorAll(".mute-video").forEach(el => {
            el.classList.add("muted-on");
            el.classList.remove("muted-off");
          });
        }
      }  
    }
  });
});
})

window.addEventListener("resize", () => {
  document.querySelectorAll(".mute-video").forEach(btn => {
    btn.classList.remove("muted-off");
    btn.classList.add("muted-on");
    const video = btn.parentElement.querySelector("video");
    const mbl_video = btn.parentElement.querySelector('.mobile_video video');
    video.muted = true;
    mbl_video.muted = true;
  });
});

  /* -------------------------------
    Helper: Get Cart Sections Data
  --------------------------------*/
  function getSectionsFormData(formData) {
    const cartDrawer = document.querySelector("cart-drawer");
    const mainCart = document.querySelector("cart-items");

    if (cartDrawer) {
      formData.append(
        "sections",
        cartDrawer.getSectionsToRender().map(s => s.id)
      );
    }

    if (mainCart) {
      formData.append(
        "sections",
        mainCart.getSectionsToRender().map(s => s.section)
      );
    }

    if (cartDrawer || mainCart) {
      formData.append("sections_url", window.location.pathname);
    }
  }

  /* -------------------------------
      Render Applied Discount UI
  --------------------------------*/
  if(window.FoxThemeSettings.discount_code){
  fetch("/cart.js").then(r => r.json()).then((data)=>{
    renderAppliedDiscount(data)
  });
  window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (cart) => {
     fetch("/cart.js").then(r => r.json()).then((data)=>{
      renderAppliedDiscount(data)
       window.initDiscountFormListeners()
     });
    });
  }
  // renderAppliedDiscount(cart)
function renderAppliedDiscount(data) {
  const container = document.querySelector('.applied-discount');
  if (!container) return;

  // Remove old discount entries
  container.innerHTML = "";

  // Filter applicable discount codes
  const applicableCodes = (data.discount_codes || [])
    .filter(dc => dc.applicable)
    .map(dc => dc.code);

  // If none, hide container
  if (applicableCodes.length === 0) {
    container.style.display = "none";
    return;
  }

  // Otherwise show container
  container.style.display = "flex";

  // Build each discount block dynamically
  applicableCodes.forEach(code => {
    const block = document.createElement("div");
    block.className = "discount-code";
    block.dataset.value = code;

    block.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" aria-hidden="true">
        <g stroke-linejoin="round" clip-path="url(#discount_svg__a)">
          <path stroke-linecap="round"
            d="M10.5 1.5H7.93a2.5 2.5 0 0 0-1.8.766L1.52 7.052a1.5 1.5 0 0 0 .02 2.101l3.48 3.48a1.25 1.25 0 0 0 1.75.016l5.116-4.926a2 2 0 0 0 .613-1.441V3.5a2 2 0 0 0-2-2"></path>
          <circle cx="9.5" cy="4.5" r="0.563" stroke-linecap="round"></circle>
          <path d="M9.49 4.49h.02v.02h-.02z"></path>
        </g>
        <defs>
          <clipPath id="discount_svg__a">
            <path fill="#fff" d="M0 0h14v14H0z"></path>
          </clipPath>
        </defs>
      </svg>

      <span class="discount-label">${code}</span>
      <button type="button" class="remove-discount">×</button>
    `;

    container.appendChild(block);
  });

  // Attach remove handlers for each new block
  attachRemoveDiscountHandlers();
  initDiscountFormListeners()
}



  /* -------------------------------
      Remove Discount on X click
  --------------------------------*/
  function attachRemoveDiscountHandlers() {
    document.querySelectorAll(".remove-discount").forEach(btn => {
      btn.onclick = async (e) => {
        const codeToRemove = e.target.closest(".discount-code").dataset.value;

        // Get all current codes except the one being removed
        const remainingCodes = [...document.querySelectorAll(".discount-code")]
          .map(div => div.dataset.value)
          .filter(code => code !== codeToRemove);

        const formData = new FormData();
        formData.append("discount", remainingCodes.join(","));
        getSectionsFormData(formData);

        const response = await fetch("/cart/update.js", {
          method: "POST",
          body: formData
        });

        const data = await response.json();
        
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, data);
        var gwp = new Gwp;
        renderAppliedDiscount(data);
        initDiscountFormListeners()
      };
    });
  }


  window.initDiscountFormListeners = function() {
    const form = document.querySelector('form[name="discount-code"]');
    if (!form) return;

    const input = form.querySelector('input[type="text"]');
    const applyBtn = form.querySelector('.discount-apply-btn');
    const errorBox = form.querySelector(".discount-error");

    // Clear old events (clone method)
    const newInputEl = input.cloneNode(true);
    const newBtnEl = applyBtn.cloneNode(true);

    input.replaceWith(newInputEl);
    applyBtn.replaceWith(newBtnEl);

    // Re-query fresh elements
    const newInput = form.querySelector('input[type="text"]');
    const newApplyBtn = form.querySelector('.discount-apply-btn');

    // Enable/Disable apply button
    newInput.addEventListener("input", () => {
      newInput.value.trim().length > 0
        ? newApplyBtn.removeAttribute("disabled")
        : newApplyBtn.setAttribute("disabled", "disabled");

      if (errorBox) {
        errorBox.style.display = "none";
        newInput.classList.remove("error");
      }
    });

    // Prevent enter key from refreshing page
    newInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        form.dispatchEvent(new Event("submit", { cancelable: true }));
      }
    });

    // SUBMIT EVENT — must use newInput!
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const discountCode = newInput.value.trim();  // <-- FIXED
      if (!discountCode) return;

      const formData = new FormData();
      getSectionsFormData(formData);

      const cart = await fetch("/cart.js").then((r) => r.json());
      const existingCodes = cart.discount_codes?.map((dc) => dc.code) || [];

      const combinedCodes = [...existingCodes, discountCode].join(",");
      formData.append("discount", combinedCodes);

      const updateResult = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      });

      const data = await updateResult.json();

      // reset input
      newInput.value = "";
      newApplyBtn.setAttribute("disabled", "disabled");
      console.log('data',data)

      const appliedCodes = data.discount_codes
        .filter((dc) => dc.applicable)
        .map((dc) => dc.code);

      const newIsAccepted = appliedCodes.includes(discountCode);

      if (!newIsAccepted) {
        errorBox.textContent = `Discount code "${discountCode}" is invalid or cannot be combined.`;
        errorBox.style.display = "block";
        newInput.classList.add("error");
        return;
      }

      // Valid code
      errorBox.style.display = "none";
      newInput.classList.remove("error");
      var gwp = new Gwp;

      window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, data);

      renderAppliedDiscount(data);
      attachRemoveDiscountHandlers();
    });
  }



  // Submit logic
document.addEventListener("DOMContentLoaded", initDiscountFormListeners);

(function () {
  if (window._mobileMenuClarityBound) return;
  window._mobileMenuClarityBound = true;

  document.addEventListener('click', function (e) {
    if (!window.clarity) return;

    const link = e.target.closest('.f-mobile-nav__link, .f-mobile-nav__sub-link');
    const arrow = e.target.closest('.f-mobile-nav__arrow');

    if (!link && !arrow) return;

    const item = (link || arrow)?.closest(
      '.f-mobile-nav__item, .f-mobile-nav__subitem, .f-mobile-nav__sub-item'
    );
    if (!item) return;

     // ✅ Detect platform (mobile menu)
    window.clarity('set', 'menu_interaction', 'mobile_mainmenu');

    // ✅ FIX: prioritize actual clicked link
    let label = 'unknown';

    if (link) {
      // 👉 DIRECT CLICK → correct label (L1/L2/L3)
      label = link.textContent.trim().replace(/\s+/g, ' ');
    } else {
      // 👉 Arrow click → fallback to parent label
      const labelEl = item.querySelector(
        ':scope > .has_menu_link .f-mobile-nav__link, :scope > .has_menu_link .f-mobile-nav__sub-link'
      );
      label = labelEl?.textContent?.trim()?.replace(/\s+/g, ' ') || 'unknown';
    }

    const hasSubmenu =
      item.classList.contains('f-mobile-nav__item--has-child') ||
      item.classList.contains('f-mobile-nav__sub-item--has-child');

    
    // ✅ OPEN
    if (arrow || (link && hasSubmenu)) {
      window.clarity('set', 'mobile_menu_open', label);
      const level = link?.closest('.f-mobile-nav__subitem') ? 'L2' : 'L1';
      console.log(`mobile_menu_open: ${level}:${label}`);
      return;
    }

    // ✅ FINAL CLICK (L1/L2/L3 leaf nodes)
    if (link && !hasSubmenu) {

      const level = link.closest('.f-mobile-nav__sub-item--level3') ? 'L3'
                  : link.closest('.f-mobile-nav__subitem') ? 'L2'
                  : 'L1';

      console.log(`mobile_menu_click: ${level}:${label}`);

      // window.clarity('set', 'mobile_menu_click', `${level}:${label}`);
      window.clarity('set', 'mobile_menu_click', `${label}`);
      return;
    }
  });

})();